import React from 'react';
import classNames from 'classnames';
import './base.module.scss';
import { LocalOfferOutlined } from '@material-ui/icons';
import moment from 'moment-timezone';
import { SuccinctCampaign } from '../../../types/membershipPlans';

type SummaryHeaderProps = {
  children: React.ReactNode;
  subLabel?: string;
  className?: string;
  styleName?: string;
};

export const SummaryHeader = ({ children, subLabel = undefined, className = undefined }: SummaryHeaderProps) => (
  <div styleName="summary-header" className={className}>
    {children}
    {subLabel && <div styleName="sub-label">{subLabel}</div>}
  </div>
);
export const SummaryBody = ({
  children,
  background = 'mint-green',
}: {
  children: React.ReactNode;
  background?: string;
}) => <div styleName={classNames('summary-body', background)}>{children}</div>;
export const SummarySplitter = () => <div styleName="summary-splitter" />;
export const SummaryPriceRow = ({
  label,
  price,
  unit,
  textSize = null,
}: {
  label: string;
  price: number;
  unit: string;
  textSize?: string | null;
}) => (
  <div styleName="summary-price-row">
    <div styleName="price-label">{label}</div>
    <div styleName="price">
      <span styleName={classNames('num', textSize)}>{price.toLocaleString()}</span>
      {unit}
    </div>
  </div>
);
export const SummarySubPriceRow = ({ label, price, unit }: { label: string; price: number; unit: string }) => (
  <div styleName={classNames('summary-sub-price-row', Math.sign(price) < 0 && 'discount')}>
    <div styleName="price-label">{label}</div>
    <div styleName="price">
      <span styleName="num">{price.toLocaleString()}</span>
      {unit}
    </div>
  </div>
);

export const SummaryTextRow = ({
  label,
  text,
  textSize = 'm',
  textAlign = 'left',
  className = undefined,
}: {
  label: string;
  text: React.ReactNode;
  textSize?: string;
  textAlign?: string;
  className?: string;
}) => (
  <div styleName={classNames('summary-text-row', textAlign)} className={className}>
    <div styleName="price-label">{label}</div>
    <div styleName={classNames('text', textSize)}>{text}</div>
  </div>
);

export const SummaryTotalPriceRow = ({ label, price, unit }: { label: string; price: number; unit: string }) => (
  <div styleName="summary-total-price-row">
    <SummaryPriceRow label={label} price={price} unit={unit} textSize="l" />
  </div>
);

export const CampaignSummary = ({
  discount,
  unit,
  type = 'm',
}: {
  discount: SuccinctCampaign;
  unit: string;
  type?: string;
}) => (
  <div styleName={classNames('campaign-summary', type)}>
    <div styleName={classNames('campaign-name', type)}>
      <LocalOfferOutlined styleName="campaign-icon" />
      {discount.name}
    </div>
    <div styleName="campaign-discount">
      {discount.discount.toLocaleString()}
      {unit}
      {type === 'm' && 'OFF'}
    </div>
  </div>
);

export const SummaryStartDateRow = ({
  startDate,
  textSize = 'm',
}: {
  startDate: string | moment.Moment;
  textSize?: string;
}) => (
  <div id="summary-start-date-row" styleName="summary-start-date-row">
    <div styleName="summary-date-row">
      <div styleName="date-label">開始日</div>
      <div styleName="date">
        <span styleName={classNames('num', textSize)}>{moment(startDate).format('YYYY年M月D日')}</span>
      </div>
    </div>
  </div>
);
